const omit = (obj, ...keys) => {
	const result = {};
	for (const key in obj) {
		if (!keys.includes(key)) {
			result[key] = obj[key];
		}
	}
	return result;
};
const pick = (obj, ...keys) => {
	const result = {};
	for (const key of keys) {
		result[key] = obj[key];
	}
	return result;
};

export { omit, pick };
//# sourceMappingURL=extract.js.map
